// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#fff","menuActiveText":"#2a8df4","menuBg":"#2a8df4"};